package org.moxultimate.topwithmox.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import org.moxultimate.topwithmox.components.layouts.PageLayoutData
import org.moxultimate.topwithmox.components.restricted.RestrictedPage
import org.moxultimate.topwithmox.core.toggle.FeatureToggle
import org.moxultimate.topwithmox.techcrud.main.TechCRUDPage

/**
 * initTechCRUDRoute
 * Registers page layout data for the /tech-crud route.
 *
 * @param ctx Kobweb route initialisation context.
 */
@InitRoute
fun initTechCRUDRoute(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData("Tech CRUD"))
}

/**
 * TechCRUDRoute
 * Renders [TechCRUDPage] when [FeatureToggle.TECH_CRUD_TOGGLE] is enabled,
 * otherwise shows [RestrictedPage].
 */
@Page(routeOverride = "tech-crud")
@Layout(".components.layouts.PageLayout")
@Composable
fun TechCRUDRoute() {
    if (FeatureToggle.TECH_CRUD_TOGGLE) TechCRUDPage() else RestrictedPage()
}
